export default class LayoutSectionMembership {
  constructor(id, sectionId, positionId) {
    this.id = id;
    this.sectionId = sectionId;
    this.positionId = positionId;
  }

  static fromAttributes({ id, layout_section_id, layout_position_id }) {
    return new LayoutSectionMembership(id, layout_section_id, layout_position_id);
  }
}
